import React, { Component } from 'react'
import { Radio, Button, DatetimePicker, Picker, Toast, Popup, Input, Loading } from 'react-vant';
import { FixedSizeList as List } from 'react-window';
import './index.scss'
import Result from './result';
const feeling = require('../../../assets/activity/blackFive/feeling.png')
const healthy = require('../../../assets/activity/blackFive/healthy.png')
const wealth = require('../../../assets/activity/blackFive/wealth.png')
const cause = require('../../../assets/activity/blackFive/cause.png')
import axios from 'axios';
import { httpUrl } from '../../../utils/apiService';

class BlackFiveReport extends Component {
  constructor(props) {
    super(props)
    this.state = {
      defaultDate: new Date(1999, 0, 1),
      popShow: false,
      resultShow: false,
      birthday: '',
      name: '',
      gender: 'Male',
      email: '',

      birthplacePop: false,
      countryList: [],
      country: '',

      cityList: [],
      cityData: {},
      city: '',
      lat: '',
      long: '',
      inputValue: '',
      searchData: [],
      showSearchData : false,

      //选择的属性
      isTab: '1',
      cityLoading: true,
    }
    this.cityListRef = React.createRef(); // 创建 ref
    this.searchListRef = React.createRef();
    this.debounceTimeout = null; // 定时器变量
  }

  componentDidMount() {
    this.getCountry();
    //this.getCity('United States');
  }

  getCity = (value) => {
    axios({
      method: 'get',
      url: httpUrl + '/api/get_city',
      params: {
        country: value,
      }
    })
      .then(response => {
        this.setState({
          cityList: response.data.data.map(item => item.city),
          cityData: response.data.data,
          cityLoading: false,
        },
        () => {
          // 滚动到顶部
          if (this.cityListRef.current) {
            this.cityListRef.current.scrollTo(0); // 调用 scrollTo 方法滚动到顶部
          }
        })
      })
      .catch(error => {
        console.error(error);
      });
  }
  getCountry = () => {
    axios({
      method: 'get',
      url: httpUrl + '/api/get_country',
    })
      .then(response => {
        this.setState({
          countryList: response.data.data,
        })
      })
      .catch(error => {
        console.error(error);
      });
  }
  getSearchResult = (inputValue) => {
    axios({
      method: 'get',
      url: httpUrl + '/api/get_country_city_and_like',
      params: {
        content: inputValue,
      }
    })
      .then(response => {
        this.setState({
          searchData: response.data.data,
          cityLoading: false,
        },
        () => {
          // 滚动到顶部
          if (this.searchListRef.current) {
            this.searchListRef.current.scrollTo(0); // 调用 scrollTo 方法滚动到顶部
          }
        })
      })
      .catch(error => {
        console.error(error);
      });
  }

  formatDateTimeToBackend(date) {
    if (!date) return '';

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从 0 开始，所以加 1
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }
  checkedBirthday = (value) => {
    const birthday = this.formatDateTimeToBackend(value)
    this.setState({
      birthday: birthday,
      defaultDate: value,
    })
  }

  onPopShow = (value, email) => {
    this.setState({
      popShow: value,
      email: email,
    })
  }
  shareFriends = () => {
    this.handleShare()
  }
  cancelPop = () => {
    this.setState({
      popShow: false
    })
    window.parent.postMessage('close_report', '*');
  }
  // handleShare = async () => {
  //   if (navigator.share) { // 检查浏览器是否支持 Web Share API
  //       try {
  //           await navigator.share({
  //               title: 'The 2025 Annual Report on Transits',
  //               text: 'Get a comprehensive report worth $199 for free now',
  //               url: 'https://master.futurecuex.com/blackFiveReport', // 替换为你要分享的 URL
  //           });
  //           console.log('Share was successful.');
  //       } catch (error) {

  //       }
  //   } else {
  //       const input = document.createElement('input');
  //       input.value = 'https://master.futurecuex.com/blackFiveReport';
  //       document.body.appendChild(input);
  //       input.select();
  //       document.execCommand('copy'); // 执行复制命令
  //       document.body.removeChild(input); // 移除临时输入框
  //       alert('The link has been copied to the clipboard! Go and share it with your friends!');
  //   }
  // };
  handleShare = () => {
    const input = document.createElement('input');
    input.value = 'https://master.futurecuex.com/blackFiveReport';
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy'); // 执行复制命令
    document.body.removeChild(input); // 移除临时输入框
    alert('The link has been copied to the clipboard! Go and share it with your friends!');
  };
  scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
  searchChange = (e) => {
    this.setState({
      inputValue: e,
    })
    // 清除之前的定时器
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }
    this.debounceTimeout = setTimeout(() => {
      if(e.trim().length >= 2){
        this.getSearchResult(e);
        this.setState({
          showSearchData: true,
          cityLoading: true,
        })
      }else if(e.trim().length == 0){
        this.setState({
          showSearchData: false,
        })
      }
    }, 500);
  }
  changeCountry = (value) => {
    this.setState({
      country: value,
      isTab: '2',
      cityLoading: true,
    })
    this.getCity(value);
  }
  changeCity = (index) => {
    this.setState({
      city: this.state.cityData[index].city,
      lat: this.state.cityData[index].lat,
      long: this.state.cityData[index].long,
      isTab: '1',
      birthplacePop: false,
    })
  }
  changeSearchValue = (index) => {
    this.setState({
      country: this.state.searchData[index].country,
      city: this.state.searchData[index].city,
      lat: this.state.searchData[index].lat,
      long: this.state.searchData[index].long,
      showSearchData: false,
      isTab:'1',
      birthplacePop: false,
      inputValue: '',
    })
  }
  render() {
    return (
      <div className="blackFiveReport">
        <div style={!this.state.resultShow ? { display: 'flex' } : { display: 'none' }}>
          <div className="main">
            {/* 顶部带表单 */}
            <div className="header">
              <div className="header_band">
                <div className="left_i"></div>f u t u r e c u e x
                <div className="right_i"></div>
              </div>
              <div className="title">The 2025 Annual Report on Transits</div>
              <div className="title_icon">
                <div className="fengshui">
                  <div className="icon"></div>
                  <div className="text">Feng Shui</div>
                </div>
                <div className="bazi">
                  <div className="icon"></div>
                  <div className="text">BaZi</div>
                </div>
                <div className="zodiac">
                  <div className="icon"></div>
                  <div className="text">Zodiac</div>
                </div>
              </div>
              {/* 分割符 */}
              <div className="hr"></div>
              <div className="theme">
                <img src={require('../../../assets/activity/blackFive/cw.png')}/>
                <img src={require('../../../assets/activity/blackFive/fl.png')}/>
                <img src={require('../../../assets/activity/blackFive/hf.png')}/>
              </div>
              <div className="from">
                <div className="from_title"></div>
                <div className="from_name">
                  <span>Name:</span>
                  <input value={this.state.name} onChange={(e) => this.setState({ name: e.target.value })} type="text" placeholder="Enter your name" class="name-input" />
                </div>
                <div className="from_gender">
                  <span>Gender:</span>
                  <Radio.Group className="radio_group" defaultValue={this.state.gender} onChange={(e) => this.setState({ gender: e })} direction="horizontal" checkedColor="hsla(33, 76%, 61%, 1)" iconSize="12px">
                    <Radio className="radio" name="Male">Male</Radio>
                    <Radio className="radio" name="Female">Female</Radio>
                    <Radio className="radio" name="Other">Other</Radio>
                  </Radio.Group>
                </div>
                <div className="from_birthday">
                  <span>Birthday:</span>
                  <DatetimePicker
                    popup={{
                      round: true,
                    }}
                    cancelButtonText='cancel'
                    confirmButtonText='confirm'
                    type='datetime'
                    value={this.state.defaultDate}
                    minDate={new Date(1900, 0, 1)}
                    maxDate={new Date(2025, 10, 1)}
                    onChange={this.checkedBirthday}
                    onConfirm={this.checkedBirthday}
                  >
                    {(val, _, actions) => {
                      return (
                        <span style={{ color: 'rgba(255, 255, 255, 0.5)' }} onClick={() => actions.open()}>{this.state.birthday ? this.state.birthday : 'Select your birthday'}</span>
                      )
                    }}
                  </DatetimePicker>
                </div>
                <div className="from_birthplace">
                  <span>Birthplace:<br /></span>
                  <span style={{ color: 'rgba(255, 255, 255, 0.5)',textAlign: 'end', }} onClick={() => this.setState({ birthplacePop: true })}>{ (this.state.country && this.state.city) ? this.state.city+" "+this.state.country : "Select your country and city."}</span>
                </div>
                <div style={{ margin: '20px 20px 5px 20px', width: '85%', opacity: this.state.birthday ? 1 : 0.5, pointerEvents: this.state.birthday ? 'auto' : 'none' }} class="footer_btn" onClick={() => this.setState({ resultShow: true })}>
                  Get right away
                </div>
                <span style={{ fontSize: '12px', fontFamily: 'none', fontWeight: '400', color: '#FFF', marginBottom: '20px' }}>
                  Get a comprehensive report worth $199 for free now
                </span>
              </div>
            </div>
            <div className="xingxing"></div>
            <div className="xingxing2"></div>
            <div className="fortuneTelling">
              <div className="feeling">
                <div className="icon"></div>
                <div className="text">feeling</div>
              </div>
              <div className="healthy">
                <div className="icon"></div>
                <div className="text">personal<br/>traits</div>
              </div>
              <div className="wealth">
                <div className="icon"></div>
                <div className="text">wealth</div>
              </div>
              <div className="cause">
                <div className="icon"></div>
                <div className="text">career</div>
              </div>
            </div>
            <div className="xingxing3"></div>
            <div className="xingxing4"></div>
            <div className="xingxing5"></div>
            <div className="big_box big_feeling">
              <img src={feeling} style={{ width: '112px', height: '84px' }} />
              <div className="text">
              Expert insights, tailored guidance, unlock the secrets to your exclusive path to love and happiness.
              </div>
            </div>
            <div className="big_box big_healthy">
              <img src={healthy} style={{ width: '112px', height: '84px' }} />
              <div className="text">
              Discover character insights, maximize opportunities, and minimize risks.
              </div>
            </div>
            <div className="big_box big_wealth">
              <img src={wealth} style={{ width: '112px', height: '84px' }} />
              <div className="text">
                Know your financial fortune trend, find the right investment methods, and seize the best time to profit.
              </div>
            </div>
            <div className="big_box big_cause">
              <img src={cause} style={{ width: '112px', height: '84px' }} />
              <div className="text">
              Discover your career potential and the best industries for you, with tailored guidance for growth.              </div>
            </div>
            <div className="anticipate">
              Anticipate the <br />
              fortune of 2025 and plan ahead
            </div>
            <div className="anticipate_subtitle">
            Annual fortune analysis is a powerful way to reshape your destiny! Identify opportunities, avoid missteps, and stay on the right path.
            </div>
            <div className="journey"></div>
            <div className="footer_btn" onClick={this.scrollToTop}>
              Get right away
            </div>
            <div style={{ textAlign: 'center', fontSize: '14px', marginTop: '5px', fontFamily: 'none', fontWeight: '400', color: '#FFF', position: 'relative', zIndex: '11' }}>
              Get a comprehensive report worth $199 for free now
            </div>
            <div className="footer_bg"></div>
            <div className="mb4"></div>
          </div>
          <Popup
            visible={this.state.birthplacePop}
            closeable
            className="birthplace"
            position='bottom'
            round
            closeOnClickOverlay={true}
            onClose={() => this.setState({ birthplacePop: false })}
          >
            <div className="birthplace_box">
              <span className="birthplace_box_title">Select Country/Region</span>
              <Input
                placeholder="Search your country/region"
                value={this.state.inputValue}
                onChange={this.searchChange}
                clearable
                clearTrigger="always"
              />
              <div className="birthplace_tab" style={this.state.showSearchData ? {display:'none'} : {display:'flex'}}>
                <span className={`birthplace_tab_text ${this.state.isTab == '1' ? 'active' : ''}`} onClick={() => this.setState({ isTab: '1' })}>{this.state.country ? this.state.country : 'Country'}</span>
                { (this.state.isTab == '2' || this.state.cityData.length > 0)&& 
                <>
                  <span className='birthplace_tab_diver'></span>
                  <span className={`birthplace_tab_text ${this.state.isTab == '2' ? 'active' : ''}`} onClick={() => this.setState({ isTab: '2' })}>{this.state.city ? this.state.city : 'City'}</span>
                </>
                }
              </div>
              <div className="country_list" style={this.state.showSearchData ? {display:'none'} : {display:'flex'}}>
                <div className="country_list_box_list" style={this.state.isTab == '1' ? { display: 'flex' } : { display: 'none' }}>
                  <List
                    height={500} // 可视区域高度
                    itemCount={this.state.countryList.length} // 总数据条数
                    itemSize={50} // 每行高度（需根据实际样式调整）
                    width="90%" // 列表宽度
                    style={{ scrollbarWidth:'none' }}
                  >
                    {({ index, style }) => (
                      <div key={index} style={style} className="country_list_box" onClick={() => this.changeCountry(this.state.countryList[index])}>
                        <span className="country_list_text">{this.state.countryList[index]}</span>
                        <img
                          style={{ width: '6px', height: '11px' }}
                          src={require('../../../assets/activity/blackFive/icon_back_country_region.png')}
                        />
                      </div>
                    )}
                  </List>
                </div>
                <div className="city_list_box_list" style={this.state.isTab == '1' ? { display: 'none' } : { display: 'flex' }}>
                  <List
                    height={500} // 可视区域高度
                    itemCount={this.state.cityList.length} // 总数据条数
                    itemSize={50} // 每行高度（需根据实际样式调整）
                    width="90%" // 列表宽度
                    ref={this.cityListRef}
                    style={this.state.cityLoading ? { display: 'none' } : { display: 'block',scrollbarWidth:'none' }}
                  >
                    {({ index, style }) => (
                      <div key={index} style={style} className="city_list_box" onClick={() => this.changeCity(index)}>
                        <span className="city_list_text">{this.state.cityList[index]}</span>
                        <img
                          style={{ width: '6px', height: '11px' }}
                          src={require('../../../assets/activity/blackFive/icon_back_country_region.png')}
                        />
                      </div>
                    )}
                  </List>
                  <div
                    style={
                      this.state.cityLoading
                        ? { width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }
                        : { display: 'none' }
                    }
                  >
                    <Loading color="#EAA95A" />
                  </div>
                </div>
              </div>
              <div className="search_list" style={this.state.showSearchData ? {display:'flex'} : {display:'none'}}>
              <div className="search_list_box_list">
                  <List
                    height={500} // 可视区域高度
                    itemCount={this.state.searchData.length} // 总数据条数
                    itemSize={50} // 每行高度（需根据实际样式调整）
                    width="90%" // 列表宽度
                    ref={this.searchListRef}
                    style={this.state.cityLoading ? { display: 'none' } : { display: 'block',scrollbarWidth:'none' }}
                  >
                    {({ index, style }) => (
                      <div key={index} style={style} className="search_list_box" onClick={() => this.changeSearchValue(index)}>
                        <span className="search_list_text">{this.state.searchData[index].city +" "+ this.state.searchData[index].country}</span>
                        <img
                          style={{ width: '6px', height: '11px' }}
                          src={require('../../../assets/activity/blackFive/icon_back_country_region.png')}
                        />
                      </div>
                    )}
                  </List>
                  <div
                    style={
                      this.state.cityLoading
                        ? { width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }
                        : { display: 'none' }
                    }
                  >
                    <Loading color="#EAA95A" />
                  </div>
                </div>
              </div>
            </div>
          </Popup>
        </div>
        {this.state.resultShow &&
          <div style={{ display: 'flex' }}>
            <Result onPopShow={this.onPopShow} name={this.state.name} birthday={this.state.birthday} gender={this.state.gender} lat={this.state.lat} long={this.state.long} />
            <div className="return" onClick={() => this.setState({ resultShow: false })}></div>
          </div>
        }
        <div className="pop" style={this.state.popShow ? { display: 'flex' } : { display: 'none' }}>
          <div className="pop_box">
            <div className="title">Sent successfully</div>
            <div className="pop_text">
              Your 2025 Annual Transit Report has been sent to <span>{this.state.email}</span>
              . Please check your inbox!
            </div>
            <div className="btn" onClick={this.shareFriends}>Share with friends</div>
            <div className="cancel" onClick={this.cancelPop}>Cancel</div>
            <div className="icon"></div>
          </div>
        </div>
      </div>
    )
  }
}

export default BlackFiveReport
